// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:58:40.067Z
// Property: Cornerstone Park (ID: 6767906449166430)
// Collections: 29 amenities, 19 floorplans (live), 28 photos, 50 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166430",
  "property_external_id": "7stk41y",
  "property_zillow_url": "https://www.zillow.com/apartments/henderson-nv/cornerstone-park/5Xhwty/",
  "property_apartments_url": "https://www.apartments.com/cornerstone-park-henderson-nv/7stk41y/",
  "property_google_business_url": "https://www.google.com/maps/place/Cornerstone+Park+Apartments+in+Henderson/data=!4m2!3m1!1s0x0:0xeae185b4943fdf3b?sa=X&ved=2ahUKEwj-76PN4aeSAxW2a_UHHXLDPRcQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40240007191",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "44CST",
  "property_status": null,
  "property_slug": "cornerstone-park",
  "property_name": "Cornerstone Park",
  "property_website_url": "https://www.cornerstoneparkapts.com/",
  "property_domain": "https://www.liveatbroadstoneheights.com/",
  "property_address": "210 Quest Park Street",
  "property_full_address": "210 Quest Park St, Henderson, NV 89074",
  "property_address_1": "210 Quest Park St",
  "property_address_2": null,
  "property_address_city": "Henderson",
  "property_address_state": "NV",
  "property_address_zip_full": null,
  "property_address_zip": "89074",
  "property_address_country": "US",
  "property_address_county": "Clark County",
  "property_neighborhood_address": "Gibson Springs",
  "property_address_latitude": "36.0430166",
  "property_address_longitude": "-115.0506768",
  "property_email": null,
  "property_phone": "(725) 210-0254",
  "property_call_tracking_phone": "844-732-3689",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Cornerstone Park in Henderson, NV, your ideal living space awaits. Choose from stylish one, two, or three-bedroom floor plans complemented by luxurious amenities like a sparkling pool, state-of-the-art fitness center, and serene dog park. Embrace comfort, community, and convenience today—your new home is just a click away!",
  "property_long_description": "Welcome to Cornerstone Park, your ideal apartment community nestled in the heart of Henderson, NV. Our diverse range of thoughtfully designed floor plans offers the perfect living space for everyone, featuring one, two, and three-bedroom options that cater to your unique lifestyle. \n\nAt Cornerstone Park, luxury meets convenience with an impressive array of amenities that elevate your everyday living experience. Relax and unwind at our sparkling swimming pool or stay fit in our state-of-the-art fitness center. Families will love our playground and spacious picnic areas, while pet owners can take advantage of our on-site dog park and pet play area. Hosting friends is a breeze with our grill and clubhouse, perfect for social gatherings and events.\n\nEnjoy seamless access to essential services, including a business center with high-speed Wi-Fi, package service, and 24-hour maintenance—all managed by our dedicated property management team right on-site. Each apartment comes equipped with modern features such as stainless steel appliances, granite or quartz countertops, walk-in closets, and your own washer/dryer for added convenience. \n\nCornerstone Park also promotes sustainability with our recycling program and offers a safe living environment with controlled access and gated entry. Whether you’re relaxing in your spacious unit with vaulted ceilings or enjoying planned social activities, there’s something for everyone in our welcoming community.\n\nDiscover your new home at Cornerstone Park today! Browse our availability or schedule a tour to witness firsthand the exceptional lifestyle that awaits you.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f6b9a-72fa-72aa-9daf-cea1900e9560.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with a rock waterfall and palm trees.",
    "public_id": "019f6b9a-72fa-72aa-9daf-cea1900e9560",
    "storage_key": "property/6767906449166430/019f6b9a-72fa-72aa-9daf-cea1900e9560.webp",
    "width": 1920,
    "height": 1279
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166430/019ffc39-6e36-7256-b26a-0ba1b7e2845b.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-6e36-7256-b26a-0ba1b7e2845b",
    "storage_key": "property/6767906449166430/019ffc39-6e36-7256-b26a-0ba1b7e2845b.m4v",
    "thumbnail_key": "property/6767906449166430/019ffc39-6e36-7256-b26a-0ba1b7e2845b_thumb.webp",
    "size_bytes": 72520323,
    "classification": "Community",
    "title": "Explore Our Vibrant Community Amenities",
    "description": "Discover the amazing amenities our community offers, including a sparkling pool, state-of-the-art fitness center, and stylish resident lounge."
  },
  "property_total_units": "310",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.61290322580645",
  "property_admin_fee": "350",
  "property_application_fee": "70.23",
  "property_fees_deposit_info": "Security Deposit\n$300-1 Month's Rent + $300.00\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Breed restrictions apply. Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Breed restrictions apply. Pets allowed: cats and dogs up to 70 lb (or 75 lb per some listings). Non‑refundable pet fee: $400 per pet. Monthly pet rent: $45 per pet. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://portal.goprisma.com/common/login?returnUrl=%2Fauth%2Flogin%3FreturnUrl%3D%252Fdashboard",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amccornerstonepark",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02ca-01d5-744e-a11d-33a54ac876d9.webp",
  "property_primary_logo_media": {
    "alt_text": "Cornerstone Park Apartments logo",
    "public_id": "019d02ca-01d5-744e-a11d-33a54ac876d9",
    "storage_key": "property/6767906449166430/019d02ca-01d5-744e-a11d-33a54ac876d9.webp",
    "width": 289,
    "height": 100
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c9-ebca-748e-9ea8-52a81bef398b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c9-ebca-748e-9ea8-52a81bef398b",
    "storage_key": "property/6767906449166430/019d02c9-ebca-748e-9ea8-52a81bef398b.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02ca-1824-779c-ae7f-8746acf587f9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cornerstone Park Apartments logo.",
    "public_id": "019d02ca-1824-779c-ae7f-8746acf587f9",
    "storage_key": "property/6767906449166430/019d02ca-1824-779c-ae7f-8746acf587f9.webp",
    "width": 289,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02ca-01d5-744e-a11d-33a54ac876d9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cornerstone Park Apartments logo",
    "public_id": "019d02ca-01d5-744e-a11d-33a54ac876d9",
    "storage_key": "property/6767906449166430/019d02ca-01d5-744e-a11d-33a54ac876d9.webp",
    "width": 289,
    "height": 100
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "739 - 1258",
  "property_sqft_min": "739",
  "property_sqft_max": "1258",
  "property_price_range": null,
  "property_price_min": "1425",
  "property_price_max": null,
  "property_available_units": 26,
  "property_facebook_url": "https://www.facebook.com/CornerstoneNV",
  "property_instagram_url": "https://www.instagram.com/cornerstoneapartmentsnv",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJR2mdnqnRyIARO98_lLSF4eo",
  "property_youtube_url": "https://www.youtube.com/watch?t=11&v=gzPd1idwytE",
  "property_yelp_url": "https://www.yelp.com/biz/cornerstone-park-henderson?start=40",
  "property_tiktok_url": "https://www.tiktok.com/discover/the-dune-apartments-henderson",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cornerstone Park",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "Welcome to Cornerstone Park, where modern living meets comfort in Henderson, NV. Our spacious one, two, and three-bedroom apartments boast stylish finishes, walk-in closets, and private balconies. Dive into fun at the pool, get active in the fitness center, or unwind at the spa. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Cornerstone Park in Henderson, NV, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom floor plans cater to your unique lifestyle. Embrace modern living and lush surroundings. Browse our available apartment homes today and find the perfect fit for your new beginning. ",
  "property_home_gallery_blurb": "At Cornerstone Park in Henderson, NV, spacious one, two, and three-bedroom apartments await your arrival. Enjoy top-notch amenities like a sparkling pool, fitness center, and a vibrant dog park. With inviting spaces and modern finishes, your perfect home is just a heartbeat away. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the vibrant heart of Henderson, Cornerstone Park offers more than just stylish one, two, and three-bedroom apartments. Embrace a lifestyle enriched by green spaces like Sunset Park and the Ethel M Botanical Cactus Garden. Nearby, educational hubs and recreational gems await—perfect for every adventurer at heart! ",
  "property_home_reviews_blurb": "Welcome to Cornerstone Park, where our residents rave about the \"beautiful location\" and \"friendly atmosphere.\" With modern apartments and a dedicated staff, including the remarkable Cynthia, your comfort is our priority. Experience a community that truly cares about you—check out our resident testimonials to see why Henderson's best living awaits!",
  "property_neighborhood_blurb": "Nestled in vibrant Henderson, Cornerstone Park offers more than just spacious one, two, and three-bedroom apartments. Embrace an active lifestyle with nearby attractions like EōS Fitness, the scenic Ethel M Botanical Cactus Garden, and the refreshing Clark County Wetlands Park. Dive into the local pulse and see what awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cornerstone Park in Henderson, NV, luxury and convenience harmonize effortlessly. Imagine unwinding by the sparkling pool or hosting friends in the clubhouse. With spacious one to three-bedroom floor plans, pet-friendly areas, and a fitness center, every detail has been crafted to elevate your lifestyle. Experience your perfect home today!",
  "property_applynow_blurb": "At Cornerstone Park in Henderson, NV, your next chapter awaits! Choose from spacious one, two, or three-bedroom floor plans featuring luxurious finishes like granite countertops and stainless steel appliances. Dive into our refreshing pool, unwind at the spa, or enjoy our vibrant community events. Secure your new sanctuary today!",
  "property_contactus_blurb": "At Cornerstone Park, nestled in vibrant Henderson, NV, we offer an array of thoughtfully designed floor plans, including one, two, and three-bedroom apartments. Each residence harmonizes comfort and style, perfect for any lifestyle. Have questions? Connect with our leasing team today to find your ideal home!",
  "property_faqs_blurb": "At Cornerstone Park in Henderson, NV, our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Curious about amenities or lease options? Dive into our FAQs page for insightful answers and make your move to a life of comfort and convenience today!",
  "property_floorplans_blurb": "At Cornerstone Park in Henderson, NV, your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Each layout offers both comfort and style, making it easy to call this vibrant community home. Browse our available apartment homes today!",
  "property_gallery_blurb": "At Cornerstone Park in Henderson, NV, envision a vibrant community where comfort meets style. Whether you choose a spacious one, two, or three-bedroom apartment, enjoy amenities like a refreshing pool, modern fitness center, and pet-friendly spaces. Picture yourself thriving in a home designed for your lifestyle!",
  "property_interactivemap_blurb": "Welcome to Cornerstone Park in Henderson, NV, where modern living meets comfort. Choose from spacious one, two, or three-bedroom apartments, all equipped with upscale amenities. Enjoy a refreshing pool, a state-of-the-art fitness center, and a vibrant community atmosphere. Check out our interactive map to find your perfect home today!",
  "property_pets_blurb": "At Cornerstone Park in vibrant Henderson, NV, your furry companions are valued residents. With spacious living and a welcoming community, cats and dogs up to 70 lbs can thrive here, complemented by green spaces perfect for play. Elevate your lifestyle in a pet-friendly haven where comfort meets convenience.",
  "property_referafriend_blurb": "At Cornerstone Park in Henderson, NV, our diverse floor plans accommodate every lifestyle, from charming one-bedrooms to spacious three-bedrooms. Share the joy of community living! Refer a friend today and enjoy the perks of great neighbors while creating lasting memories together. Your new home awaits!",
  "property_residentaccess_blurb": "At Cornerstone Park in Henderson, NV, our spacious one, two, and three-bedroom floor plans are thoughtfully designed for modern living. Access your resident portal to conveniently manage rent payments, schedule maintenance, and enjoy a seamless community experience tailored just for you! Your comfort is just a click away.",
  "property_reviews_blurb": "At Cornerstone Park in Henderson, NV, residents rave about our friendly community and exceptional staff, with one saying, “the office staff greets you with warmth and professionalism.” Experience the beautifully maintained grounds and modern amenities that make living here a delight. Don’t just take our word for it; see what our residents have to say!",
  "property_created_at": "1759782548761",
  "property_scheduletour_blurb": "At Cornerstone Park in Henderson, NV, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—are designed for every lifestyle. Experience a vibrant community where comfort meets convenience. Schedule a tour today and hear firsthand how our residents celebrate life in their homes!",
  "property_thankyou_blurb": "Thank you for reaching out to Cornerstone Park in Henderson, NV! Our diverse floor plans—ranging from cozy one bedrooms to spacious three bedrooms—are designed to fit your unique lifestyle. A team member will connect with you soon to help you find your perfect home in our vibrant community!",
  "property_virtualtours_blurb": "Step into Cornerstone Park in Henderson, NV, where spacious one, two, and three-bedroom apartments blend comfort with style. Immerse yourself in our vibrant community through an engaging virtual tour, and visualize your new home today. Take the first step towards your dream apartment experience—your ideal living space awaits!",
  "property_copyright": "2025 All Rights Reserved. Cornerstone Park",
  "property_seo_title_home": "Cornerstone Park |  Apartments in Henderson, NV",
  "property_seo_description_home": "Discover your ideal home at Cornerstone Park, Henderson, NV! Choose from modern one, two, or three-bedroom floor plans. Browse now!",
  "property_seo_title_floorplans": "Floor Plans | Apartments for Rent in Henderson, NV",
  "property_seo_description_floorplans": "Discover your ideal home at Cornerstone Park, Henderson, NV! Choose from modern one, two, or three-bedroom floor plans. Browse now!",
  "property_seo_title_amenities": "Amenities | Pet Friendly Henderson Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Cornerstone Park in Henderson, NV! Enjoy resort-style amenities and modern floor plans in a vibrant community.",
  "property_seo_title_gallery": "Gallery | Apartments in Henderson, NV For Rent",
  "property_seo_description_gallery": "Discover apartment living in Henderson, NV at Cornerstone Park, with our gallery showcasing large floor plans, pet-friendly amenities, and community features.",
  "property_seo_title_virtualtours": "Virtual Tours | Luxury Apts in Henderson, NV",
  "property_seo_description_virtualtours": "Experience the charm of Cornerstone Park in Henderson, NV! Take a virtual tour of our stunning one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Apartments for Rent in Henderson, NV",
  "property_seo_description_interactivemap": "Find your perfect home at Cornerstone Park in Henderson, NV! Use our interactive map to explore spacious floor plans and top-notch amenities tailored for you.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Las Vegas For Rent",
  "property_seo_description_neighborhood": "Cornerstone Park at Henderson, NVis conveniently located near Downtown and I-95, offering easy access to The Gardens Mall, BallenIsles Country Club, and more!",
  "property_seo_title_contact": "Contact Us | Luxury Apts in Henderson, NV",
  "property_seo_description_contact": "Reach out to Cornerstone Park in Henderson, NV! Our friendly leasing team is ready to answer your questions about our cozy one, two, and three-bedroom options.",
  "property_seo_title_faqs": "FAQ | Apartments for Rent in Luxury Apts in Henderson, NV",
  "property_seo_description_faqs": "Find answers to common questions about our apartments in Henderson, NV, at Cornerstone Park. Our FAQ page provides all the information you need.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Henderson, NV",
  "property_seo_description_reviews": "Join the Cornerstone Park community in Henderson, NV! Read resident reviews to see why our vibrant amenities and spacious apartments make home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Henderson, NV",
  "property_seo_description_applynow": "Experience luxury living at Cornerstone Park in Henderson, NV! Choose from spacious floor plans, enjoy top-notch amenities, and embrace an active lifestyle.",
  "property_seo_title_residentaccess": "Resident Access | Apartments in Henderson, NV",
  "property_seo_description_residentaccess": "Unlock convenience at Cornerstone Park! Log into your resident portal for easy rent payments, maintenance requests, and community updates in Henderson, NV.",
  "property_seo_title_referafriend": "Refer A Friend | Cornerstone Park",
  "property_seo_description_referafriend": "Refer a friend to Cornerstone Park in Henderson, NV—where great friendships bloom and neighbors become family. Share the joy of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments for Rent in Henderson NV",
  "property_seo_description_scheduletour": "Discover vibrant living at Cornerstone Park, Henderson, NV. Schedule your tour today to find the perfect home with stunning amenities!",
  "property_seo_title_privacy": "Privacy Policy | Cornerstone Park",
  "property_seo_description_privacy": "At Cornerstone Park in Henderson, NV, your privacy matters. Learn how we protect your information and ensure a safe living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Cornerstone Park",
  "property_seo_description_accessibility": "Experience seamless living at Cornerstone Park in Henderson, NV. Our commitment to digital inclusion ensures everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Cornerstone Park",
  "property_seo_description_sitemap": "Navigate your way through Cornerstone Park in Henderson, NV! Access our sitemap for a seamless journey to luxury living and vibrant community amenities.",
  "property_seo_title_thankyou": "Thank You | Apartments in Henderson, NV",
  "property_seo_description_thankyou": "Thank you for reaching out to Cornerstone Park in Henderson, NV! Our team will be in touch soon to help you find your perfect home sweet home.",
  "property_seo_title_pets": "Pets | Apartments for Rent in Luxury Apts in Henderson, NV",
  "property_seo_description_pets": "At Cornerstone Park in vibrant Henderson, NV, your furry companions are valued residents.Elevate your lifestyle in a pet-friendly haven today",
  "property_updated_at": "1786643056476",
  "amenities": [
    {
      "id": "custom_763fa669-8390-41e8-be76-558ae88db978",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-style swimming pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fb8fada5-f174-4b05-b37d-7312dfa9abce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "All Season Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a21aced8-20eb-4df8-b732-ac89fcad6b18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Community Barbecue Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9d2d4af4-bb8e-4796-87e2-96f5f1069b72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Fire pit lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_26599584-6ccd-4e2c-bdbe-e59cc4ac1d2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Stop and play tot lot area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fee1ab07-85ae-4873-b990-ac9868d55dfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Sun protected garage parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a995a236-c258-45de-a583-eefa65ac682b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4ce0837e-3490-496f-a281-37c793dacafe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Fitness center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5d612728-922d-4873-9f71-c0b05854c398",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_949397ca-85b0-4703-8812-a8b7b37fb6d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Free Wifi in resident business center/lounge area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_762865b4-a726-4a68-bf80-d84b3b000b9a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Billiards Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b7c72230-c4c6-4706-a595-2b1acf774180",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Automated Coffee Barista",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4bd440da-757d-4f20-9d0a-b5bbbbccc5b3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Stunning Resident Clubhouse w/ Great Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_084d1e9c-6530-45aa-b5a3-f9e6531bcbea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious living areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7d470b55-40be-4803-8654-f66bd922ff71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Large windows throughout",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2350a8fe-cd4b-46eb-a1bc-527e20be9d37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Central air conditioning and heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_65b6a7f4-015f-4641-af01-5ff764221ea0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a1dc916b-96ce-442e-9c11-916ca1759544",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-in closets*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d08dbbcf-8208-43c5-a635-b699c7c7fb4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Utility and linen closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7a6bb08c-f915-47ed-94d0-bf090cca23d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant exterior French doors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2fac4dae-294c-40e4-ac83-880d2ced8a68",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Granite kitchen and vanity countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_59261c94-84b4-4ec7-a7b6-f3f32e6bb38d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Separate dining areas*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4751139b-cf4b-4a21-a9a6-c5d0eac97c7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen pantries*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_273f3c84-2a46-4839-a5bc-780bcff346c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Full-size washers and dryers*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b37e5702-28c8-40e9-8b6d-8a23e61f72be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Private patio/balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d3fbc561-f9b2-484c-9008-720299212ae3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_87e2f3fe-9478-47b6-a7f7-d53797af1508",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "City, Mountain, or Park Views*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f7d7179b-7908-4b66-b232-32c5da297a6e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Rentable Storage Rooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a2fe447d-06e2-4d63-95bf-c936e9b54322",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Interiors*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_11f2f325-9d4d-4596-8daf-58e3ebcf4acc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-8669-735b-ad71-d4893c4b33ca.webp",
      "image_media": {
        "alt_text": "Cornerstone Park Apartments monument sign with desert landscaping and building exterior in the background.",
        "public_id": "01a016c7-8669-735b-ad71-d4893c4b33ca",
        "storage_key": "property/6767906449166430/01a016c7-8669-735b-ad71-d4893c4b33ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Cornerstone Park Apartments, featuring a prominent monument sign and beautiful desert landscaping.",
      "link": "",
      "alt_text": "Cornerstone Park Apartments monument sign with desert landscaping and building exterior in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07e1f7cd-9ce5-4356-bca7-1a84806d2728",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-8bcb-74e4-9e57-dde678edec13.webp",
      "image_media": {
        "alt_text": "Leasing center exterior with palm trees and a water feature at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-8bcb-74e4-9e57-dde678edec13",
        "storage_key": "property/6767906449166430/01a016c7-8bcb-74e4-9e57-dde678edec13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the leasing center, an inviting space with lush landscaping and a serene water feature, offering a glimpse of the community's ambiance.",
      "link": "",
      "alt_text": "Leasing center exterior with palm trees and a water feature at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d1c83bd-71b3-4dc8-9bca-cfaa215abd37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-c590-776b-91dc-187f6e54cb35.webp",
      "image_media": {
        "alt_text": "Interior view of the apartment community lounge area with modern furniture and ample lighting at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-c590-776b-91dc-187f6e54cb35",
        "storage_key": "property/6767906449166430/01a016c7-c590-776b-91dc-187f6e54cb35.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a contemporary design, perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Interior view of the apartment community lounge area with modern furniture and ample lighting at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49a5e828-df0a-4e9e-bbb5-f59d4a219402",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-8531-7082-a621-b7417a602d36.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with comfortable seating, a coffee bar, and a sleek kitchen area at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-8531-7082-a621-b7417a602d36",
        "storage_key": "property/6767906449166430/01a016c7-8531-7082-a621-b7417a602d36.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our vibrant community lounge, featuring stylish seating, a convenient coffee bar, and a modern kitchen area perfect for residents to gather and socialize.",
      "link": "",
      "alt_text": "Modern apartment building lobby with comfortable seating, a coffee bar, and a sleek kitchen area at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d56193e2-6964-440d-90a9-9e77395729d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-9188-7188-a409-bf67329e662e.webp",
      "image_media": {
        "alt_text": "Modern community kitchen with island and bar stools at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-9188-7188-a409-bf67329e662e",
        "storage_key": "property/6767906449166430/01a016c7-9188-7188-a409-bf67329e662e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the sleek, modern design of our community kitchen, perfect for entertaining or casual gatherings.",
      "link": "",
      "alt_text": "Modern community kitchen with island and bar stools at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92590d29-8d0a-48f2-b2c5-7a22d6a395f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-9db1-7001-a1a3-5f63c3272cd3.webp",
      "image_media": {
        "alt_text": "Community coffee bar area with high-top tables and stools, and a coffee station with a mini-fridge at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-9db1-7001-a1a3-5f63c3272cd3",
        "storage_key": "property/6767906449166430/01a016c7-9db1-7001-a1a3-5f63c3272cd3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our resident coffee bar, featuring comfortable seating and a convenient beverage station.",
      "link": "",
      "alt_text": "Community coffee bar area with high-top tables and stools, and a coffee station with a mini-fridge at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9aecb88d-b142-4dd8-894d-9091752cd953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-8465-712e-a247-99d710b8b9c3.webp",
      "image_media": {
        "alt_text": "Welcome to Fabulous Las Vegas Nevada mural and pool table in community lounge at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-8465-712e-a247-99d710b8b9c3",
        "storage_key": "property/6767906449166430/01a016c7-8465-712e-a247-99d710b8b9c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the vibrant community lounge featuring a striking 'Welcome to Las Vegas' mural, comfortable seating, and a pool table, with views of the outdoor pool area.",
      "link": "",
      "alt_text": "Welcome to Fabulous Las Vegas Nevada mural and pool table in community lounge at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fb824d4-68f8-407c-8493-692bc5e627e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-ce44-7725-b992-4f0f91243f42.webp",
      "image_media": {
        "alt_text": "Community business center with computers and a large table at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-ce44-7725-b992-4f0f91243f42",
        "storage_key": "property/6767906449166430/01a016c7-ce44-7725-b992-4f0f91243f42.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our modern business center, featuring ample computer workstations and a comfortable communal table perfect for collaboration or quiet work.",
      "link": "",
      "alt_text": "Community business center with computers and a large table at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_684abfcd-e6f9-43e8-aae4-3c07af0d3d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-8d02-75b8-a5f3-b78c3099db72.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, rowing machines, and free weights.",
        "public_id": "01a016c7-8d02-75b8-a5f3-b78c3099db72",
        "storage_key": "property/6767906449166430/01a016c7-8d02-75b8-a5f3-b78c3099db72.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and a comprehensive selection of free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, rowing machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adc57767-5437-47c2-8d12-6c3149a845ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016d4-ed97-737d-a0f9-f611de931a80.webp",
      "image_media": {
        "alt_text": "Spin bikes and exercise equipment in a modern fitness center with large mirrors.",
        "public_id": "01a016d4-ed97-737d-a0f9-f611de931a80",
        "storage_key": "property/6767906449166430/01a016d4-ed97-737d-a0f9-f611de931a80.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment, free weights, and functional training space.",
      "link": "",
      "alt_text": "Spin bikes and exercise equipment in a modern fitness center with large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0053f6b5-82b4-4f47-80e0-f8fbc8ccbdfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-fa2a-76d3-ba9e-0d26097cd8f7.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fireplace and modern chairs at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-fa2a-76d3-ba9e-0d26097cd8f7",
        "storage_key": "property/6767906449166430/01a016c7-fa2a-76d3-ba9e-0d26097cd8f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor seating area, complete with a cozy fireplace and comfortable modern chairs.",
      "link": "",
      "alt_text": "Outdoor seating area with fireplace and modern chairs at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2078f58-80f0-46c9-a438-464b0d5063d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-9fc8-76dd-be1b-e218324f28b5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with water feature and lounge chairs in a multifamily community.",
        "public_id": "01a016c7-9fc8-76dd-be1b-e218324f28b5",
        "storage_key": "property/6767906449166430/01a016c7-9fc8-76dd-be1b-e218324f28b5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a relaxing water feature and comfortable lounge areas, perfect for unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with water feature and lounge chairs in a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_becab11a-a5b6-4d77-b42a-e6a7a11a2e9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-e341-710f-8bcd-06e6bcb5168e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, next to apartment buildings at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-e341-710f-8bcd-06e6bcb5168e",
        "storage_key": "property/6767906449166430/01a016c7-e341-710f-8bcd-06e6bcb5168e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, next to apartment buildings at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d10a1efe-c410-4f63-8c0a-90d4f547b4a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f777e-b2ba-7585-8ad9-1bcfd84b2abc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a tanning ledge and cabana at Cornerstone Park in Henderson, NV.",
        "public_id": "019f777e-b2ba-7585-8ad9-1bcfd84b2abc",
        "storage_key": "property/6767906449166430/019f777e-b2ba-7585-8ad9-1bcfd84b2abc.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with a tanning ledge and a shaded cabana for ultimate comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a tanning ledge and cabana at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a54c069-4e55-48ce-80af-bb08e9f75dc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-e3d1-7349-9801-7a4c51910f1b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-e3d1-7349-9801-7a4c51910f1b",
        "storage_key": "property/6767906449166430/01a016c7-e3d1-7349-9801-7a4c51910f1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, complete with comfortable lounge seating and lush palm trees, creating your perfect oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63b0b6c9-75d0-4207-aff9-cbe0b5c98c48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-fa1b-722f-abb8-8520e433cf34.webp",
      "image_media": {
        "alt_text": "Outdoor grills and swimming pool area with lounge chairs and palm trees.",
        "public_id": "01a016c7-fa1b-722f-abb8-8520e433cf34",
        "storage_key": "property/6767906449166430/01a016c7-fa1b-722f-abb8-8520e433cf34.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and outdoor grilling stations, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Outdoor grills and swimming pool area with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef59906e-01ba-4180-8b9d-e4dcf2c67328",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c8-02f3-723b-b07c-7127ae116762.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and palm trees at a multifamily property at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c8-02f3-723b-b07c-7127ae116762",
        "storage_key": "property/6767906449166430/01a016c8-02f3-723b-b07c-7127ae116762.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and palm trees at a multifamily property at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_921d3829-9b9e-4687-a50c-3e95a9213006",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c8-04dd-708c-922d-2018773b2c7f.webp",
      "image_media": {
        "alt_text": "Playground with slides and stairs in front of apartment buildings at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c8-04dd-708c-922d-2018773b2c7f",
        "storage_key": "property/6767906449166430/01a016c8-04dd-708c-922d-2018773b2c7f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground, perfect for children to play and explore.",
      "link": "",
      "alt_text": "Playground with slides and stairs in front of apartment buildings at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e7aaedb-cfa9-45b3-8a19-595f1e92c624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-844a-72ed-910e-b672b027507e.webp",
      "image_media": {
        "alt_text": "Outdoor green space with a picnic table and benches, adjacent to apartment buildings.",
        "public_id": "01a016c7-844a-72ed-910e-b672b027507e",
        "storage_key": "property/6767906449166430/01a016c7-844a-72ed-910e-b672b027507e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the lush green outdoor spaces and picnic areas available at our community.",
      "link": "",
      "alt_text": "Outdoor green space with a picnic table and benches, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a7794a4-6034-484f-bcb3-2c0220fc9c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016ce-de8f-7222-9fc9-b9d026da2d29.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and wood-look flooring at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016ce-de8f-7222-9fc9-b9d026da2d29",
        "storage_key": "property/6767906449166430/01a016ce-de8f-7222-9fc9-b9d026da2d29.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek dark wood cabinetry, durable granite countertops, and top-of-the-line stainless steel appliances. The elegant design and practical layout make this kitchen a joy to cook and entertain in.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and wood-look flooring at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_934e308f-b115-4d1c-a84e-868e1ce98201",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-c664-7580-aef2-cb9cc7474670.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-c664-7580-aef2-cb9cc7474670",
        "storage_key": "property/6767906449166430/01a016c7-c664-7580-aef2-cb9cc7474670.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a granite-top island with bar seating, dark wood cabinetry, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d95206b-1731-4da9-b53d-929289e82178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-d024-764d-a031-212e9429f4c6.webp",
      "image_media": {
        "alt_text": "Living room and open kitchen area with island seating and a TV at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-d024-764d-a031-212e9429f4c6",
        "storage_key": "property/6767906449166430/01a016c7-d024-764d-a031-212e9429f4c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a TV and comfortable seating, seamlessly flowing into an open-concept kitchen with island bar seating.",
      "link": "",
      "alt_text": "Living room and open kitchen area with island seating and a TV at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8acc93b0-6316-4cf0-9db6-d76aaef58a04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-da9d-766b-be2e-3906c42b9033.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, armchair, coffee table, and laundry area at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-da9d-766b-be2e-3906c42b9033",
        "storage_key": "property/6767906449166430/01a016c7-da9d-766b-be2e-3906c42b9033.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sectional sofa, accent armchair, and a convenient in-unit laundry area. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, armchair, coffee table, and laundry area at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d12a8504-912b-4571-a053-3c797e4ddcbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016d2-05ee-742d-8076-e662515a8418.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, white linens, and a green accent pillow at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016d2-05ee-742d-8076-e662515a8418",
        "storage_key": "property/6767906449166430/01a016d2-05ee-742d-8076-e662515a8418.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, white linens, and a green accent pillow at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f73148b-3175-4b9e-b238-f8803a0367c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-e250-73e3-82d8-116fa6041cf1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dark wood vanity, granite countertop, white sink, toilet, and a white bathtub with a shower curtain at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-e250-73e3-82d8-116fa6041cf1",
        "storage_key": "property/6767906449166430/01a016c7-e250-73e3-82d8-116fa6041cf1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring a spacious vanity with granite countertops, a modern sink, and elegant fixtures. Enjoy a relaxing bath or shower in the pristine tub, all within a clean and stylish living space.",
      "link": "",
      "alt_text": "Modern bathroom with a dark wood vanity, granite countertop, white sink, toilet, and a white bathtub with a shower curtain at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23aff29b-a1a0-459d-aff8-369fb33097eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-d14c-758c-881e-a261e99f4194.webp",
      "image_media": {
        "alt_text": "A beautifully appointed bedroom with a large bed, nightstand, and closet at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-d14c-758c-881e-a261e99f4194",
        "storage_key": "property/6767906449166430/01a016c7-d14c-758c-881e-a261e99f4194.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed, a stylish nightstand, and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "A beautifully appointed bedroom with a large bed, nightstand, and closet at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fab5641a-e97e-4946-952e-c9578363f39c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-d266-742b-a7e1-0d6d47f7107d.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet with a basket of towels and jars of laundry supplies on a shelf at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-d266-742b-a7e1-0d6d47f7107d",
        "storage_key": "property/6767906449166430/01a016c7-d266-742b-a7e1-0d6d47f7107d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with ample storage for all your laundry needs. Perfect for busy lifestyles.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet with a basket of towels and jars of laundry supplies on a shelf at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce949210-94a4-4ee6-8296-3c9f4518bdac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/01a016c7-890a-71ba-8f46-2aa2b0f390fa.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and balconies at Cornerstone Park in Henderson, NV.",
        "public_id": "01a016c7-890a-71ba-8f46-2aa2b0f390fa",
        "storage_key": "property/6767906449166430/01a016c7-890a-71ba-8f46-2aa2b0f390fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring individual garages, balconies, and stucco exteriors under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and balconies at Cornerstone Park in Henderson, NV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c82ea277-e22d-4e64-8e8e-da7d14f7feae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1421 W Sunset Rd, Henderson, NV 89014, USA",
      "poi_short_description": "Family-friendly eatery specializing in steaks and ribs and offering a variety of casual eats along with country dancing.",
      "poi_long_description": "People say this steakhouse serves delicious ribs, steaks, and margaritas, and they highlight the fresh bread and cinnamon butter. They also like the fun, lively atmosphere, the fast service, and the attentive staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-225a-770f-94d5-ff6b8ae52319.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-225a-770f-94d5-ff6b8ae52319",
        "storage_key": "property/6767906449166430/019d02c8-225a-770f-94d5-ff6b8ae52319.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/henderson?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=11671240394778838166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0632347",
      "poi_longitude": "-115.0475945",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 702-846-5970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9dPCKnRyIARloT7Wk2T-KE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c4281c62-2a6f-4f22-b5a9-81503bff5d94",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Galleria At Sunset",
      "poi_type": "Shopping & Retail",
      "poi_address": "1300 W Sunset Rd, Henderson, NV 89014, USA",
      "poi_short_description": "Popular indoor shopping center with an array of clothing shops and eateries, plus a food court, a farmers market and a carousel.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, from popular brands to unique boutiques, and a diverse selection of dining options in the food court and sit-down restaurants. They highlight the spacious, well-maintained layout, and the welcoming, lively atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-232c-7791-afbe-737b65393f27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-232c-7791-afbe-737b65393f27",
        "storage_key": "property/6767906449166430/019d02c8-232c-7791-afbe-737b65393f27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.galleriaatsunset.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16704739515156728367&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "galleria-at-sunset",
      "poi_latitude": "36.06729079999999",
      "poi_longitude": "-115.0420052",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 702-434-2409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-589d-75f3-8b73-a349cb9aabcc",
        "storage_key": "property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJszO2Q_TQyIARLwpZYhUo0-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f2c1de26-9650-4440-97a1-3d049478f127",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 S Green Valley Pkwy, Henderson, NV 89012, USA",
      "poi_short_description": "Chain grocery store supplying quality organic products, prepared foods, and baked goods.",
      "poi_long_description": "People say this grocery store offers a great salad bar, fresh produce, and a wide selection of ready-to-eat foods, including pizza and sushi. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-2930-77b8-857a-0f8e7aed28c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-2930-77b8-857a-0f8e7aed28c7",
        "storage_key": "property/6767906449166430/019d02c8-2930-77b8-857a-0f8e7aed28c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/henderson?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8522520288239881635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.0234338",
      "poi_longitude": "-115.0824622",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-361-8183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a4-705e-9586-055ee9dbfc61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a4-705e-9586-055ee9dbfc61",
        "storage_key": "property/6767906449166430/019d02c8-58a4-705e-9586-055ee9dbfc61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6lP5dzRyIARow2ZQwwTRnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_df6cbf0a-0f71-4688-8292-054acbfc82c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Touro University Nevada",
      "poi_type": "Education",
      "poi_address": "874 American Pacific Dr, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-28f2-73de-8602-8ed1ca546354.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-28f2-73de-8602-8ed1ca546354",
        "storage_key": "property/6767906449166430/019d02c8-28f2-73de-8602-8ed1ca546354.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tun.touro.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16919049400335013713&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "touro-university-nevada",
      "poi_latitude": "36.0431666",
      "poi_longitude": "-115.0239795",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-777-8687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz28i7BfRyIARURdB5MmJzOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_469745f4-264f-4d28-8785-8c2e0ccbdb0d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Roseman University of Health Sciences",
      "poi_type": "Education",
      "poi_address": "11 Sunset Way, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-2a6d-70e0-a91b-09c2860bdd5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-2a6d-70e0-a91b-09c2860bdd5f",
        "storage_key": "property/6767906449166430/019d02c8-2a6d-70e0-a91b-09c2860bdd5f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.roseman.edu/?utm_source=google&utm_medium=organic&utm_campaign=henderson_gbplisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002644649480166706&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseman-university-of-health-sciences",
      "poi_latitude": "36.0734556",
      "poi_longitude": "-115.06482",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 702-990-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWcxMWzQyIARMh02GP8b6g0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_35effd5d-b5b6-475f-9537-34e44a31f087",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Lee's Family Forum",
      "poi_type": "Entertainment",
      "poi_address": "200 S Green Valley Pkwy, Henderson, NV 89012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this arena offers a variety of events, including concerts, hockey games, and other sporting events. They highlight the comfortable seating, good sound system, and clean facilities. They also like the family-friendly atmosphere and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-2f84-74eb-af72-66d2af00e044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-2f84-74eb-af72-66d2af00e044",
        "storage_key": "property/6767906449166430/019d02c8-2f84-74eb-af72-66d2af00e044.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://leesfamilyforum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2983949974640813899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lees-family-forum",
      "poi_latitude": "36.0192187",
      "poi_longitude": "-115.0813502",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-645-4259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TNhrFvRyIARS2cAOrEeaSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c1cbc1e4-6aea-4b36-9747-7cfb1152931c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Las Vegas Athletic Clubs - Henderson",
      "poi_type": "Health and Wellness",
      "poi_address": "1195 Wellness Pl., Henderson, NV 89011, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this gym offers a wide variety of equipment, a great sauna, and a clean facility. They also highlight the friendly and helpful staff, and the affordable prices.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-35fd-701a-994e-aa7561ce138a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-35fd-701a-994e-aa7561ce138a",
        "storage_key": "property/6767906449166430/019d02c8-35fd-701a-994e-aa7561ce138a.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.lvac.com/locations/henderson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17887573427831471092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-vegas-athletic-clubs---henderson",
      "poi_latitude": "36.0764335",
      "poi_longitude": "-115.0378623",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-566-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUKmv3rRyIAR9Hucm0JtPfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_30244eba-076c-46b7-bba5-f9bc3cfee217",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "121 Carnegie St, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym has a wide variety of amenities, including basketball courts with high school, college, and NBA three-point lines. They also highlight the clean facilities and the availability of childcare.\n\nOther reviews mention the membership can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-35e0-705a-b9cb-1b6266f214d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-35e0-705a-b9cb-1b6266f214d3",
        "storage_key": "property/6767906449166430/019d02c8-35e0-705a-b9cb-1b6266f214d3.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/nv/henderson-green-valley.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=10952260047688760852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0217722",
      "poi_longitude": "-115.0938597",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-802-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVzMX9jRyIARFP4wXnw-_pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e026987b-ff33-4540-a1dd-7239000ba91c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Las Vegas Athletic Clubs - Green Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "9065 S Eastern Ave, Las Vegas, NV 89123, USA",
      "poi_short_description": "Family-oriented fitness center with a pool, sauna, running track, and racquetball.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, a pool, and a sauna. They also highlight the friendly staff and the clean facilities.\n\nOther reviews mention the pool and sauna can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-3984-74db-a74c-9125649686a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-3984-74db-a74c-9125649686a5",
        "storage_key": "property/6767906449166430/019d02c8-3984-74db-a74c-9125649686a5.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.lvac.com/locations/green-valley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3225135382736334378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-vegas-athletic-clubs---green-valley",
      "poi_latitude": "36.025325",
      "poi_longitude": "-115.12075",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-853-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdX8AEnOyIARKu6KCIv7wSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8eb0921d-2a4e-4ce7-8216-08af54008213",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "35 S Stephanie St, Henderson, NV 89012, USA",
      "poi_short_description": "Chain fitness center with a turf functional training area and group fitness classes.",
      "poi_long_description": "People say this gym offers a wide variety of cardio and weight equipment, and the facilities are clean and well-maintained. They also highlight the friendly, helpful, and motivating staff, and the positive and inclusive vibe.\n\nOther reviews mention the sauna can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-35c2-746d-851b-610f2b8bb216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-35c2-746d-851b-610f2b8bb216",
        "storage_key": "property/6767906449166430/019d02c8-35c2-746d-851b-610f2b8bb216.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/las-vegas-southeast/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14776023351109489618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "36.0280299",
      "poi_longitude": "-115.0504579",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-269-0828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_qkYp_RyIAR0hPCe_P6Ds0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_24e1ac75-300a-496b-8b73-a4d3a00a7cf6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9850 S Maryland Pkwy, Las Vegas, NV 89183, USA",
      "poi_short_description": "Well-lit gym, part of a chain offering massage chairs, tanning, and other amenities.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, and additional amenities like yoga mats and stretching mats. They also highlight the clean facilities, spacious locker rooms, and warm showers with good water pressure, as well as the friendly and helpful staff.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-3a89-77ba-909c-39f64b972a39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-3a89-77ba-909c-39f64b972a39",
        "storage_key": "property/6767906449166430/019d02c8-3a89-77ba-909c-39f64b972a39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/las-vegas-silverado-ranch-nv?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8620086064635936682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0101254",
      "poi_longitude": "-115.1340747",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-462-9088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2jlv13OyIARqn_rx5qyoHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7bb6f387-fbde-4271-8971-4cb614a9b876",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Henderson Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1050 W Galleria Dr, Henderson, NV 89011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-3f1c-734e-92fc-0e883f34e3be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-3f1c-734e-92fc-0e883f34e3be",
        "storage_key": "property/6767906449166430/019d02c8-3f1c-734e-92fc-0e883f34e3be.webp",
        "width": 724,
        "height": 407
      },
      "poi_business_url": "https://www.hendersonhospital.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15514515415369043216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henderson-hospital",
      "poi_latitude": "36.0727599",
      "poi_longitude": "-115.0303628",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-963-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c15-707a-aaa2-e14169b2a251.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c15-707a-aaa2-e14169b2a251",
        "storage_key": "property/6767906449166430/019d02c8-5c15-707a-aaa2-e14169b2a251.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24MxyuzQyIAREM1kI5KhTtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6d4c7c81-bb27-4ccc-a844-98ec6930a2a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Dignity Health - St. Rose Dominican Hospital, Siena Campus - Henderson, NV",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 St Rose Pkwy, Henderson, NV 89052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-3f8b-74e5-aea3-f1d408b363f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-3f8b-74e5-aea3-f1d408b363f0",
        "storage_key": "property/6767906449166430/019d02c8-3f8b-74e5-aea3-f1d408b363f0.webp",
        "width": 1200,
        "height": 770
      },
      "poi_business_url": "https://locations.dignityhealth.org/dignity-health-st-rose-dominican-hospital-siena-campus-henderson-nv",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999274636308605503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dignity-health---st-rose-dominican-hospital-siena-campus---henderson-nv",
      "poi_latitude": "36.0042484",
      "poi_longitude": "-115.1150318",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-616-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c15-707a-aaa2-e14169b2a251.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c15-707a-aaa2-e14169b2a251",
        "storage_key": "property/6767906449166430/019d02c8-5c15-707a-aaa2-e14169b2a251.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJISV_jBLOyIARP2qfabDZvhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7a59cb05-64a1-45fb-8eb0-5dcf3c495836",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Sunset Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 E Sunset Rd, Las Vegas, NV 89120, USA",
      "poi_short_description": "Sprawling park, surrounded by trees and home to geese and ducks, with a pond and playground.",
      "poi_long_description": "People say this park offers a variety of activities, including walking trails, sports courts, a lake with ducks, and picnic areas. They highlight the relaxing and beautiful atmosphere, especially around sunset, and the well-maintained grounds. They also like the spaciousness and the mix of people enjoying the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-409a-75f0-95eb-58efa74769cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-409a-75f0-95eb-58efa74769cb",
        "storage_key": "property/6767906449166430/019d02c8-409a-75f0-95eb-58efa74769cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clarkcountynv.gov/government/departments/parks___recreation/services/area_reservations/sunset_park_webpage.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052257275142238047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sunset-park",
      "poi_latitude": "36.065649",
      "poi_longitude": "-115.111595",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 702-455-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMf3EsfPPyIARX28g7uzv_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57d79b69-b4a0-4136-b21d-091a8ebbd42c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "350 S Racetrack Rd, Henderson, NV 89015, USA",
      "poi_short_description": "Multi-zone dog park, playground and pool, plus a senior center and sports courts.",
      "poi_long_description": "People say this park offers a variety of sports fields, playgrounds, walking trails, and a dog park. They highlight the clean restrooms, spacious fields, and well-maintained grounds. They also like the ample parking and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-40ba-725f-8ab9-faac4a2a5964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-40ba-725f-8ab9-faac4a2a5964",
        "storage_key": "property/6767906449166430/019d02c8-40ba-725f-8ab9-faac4a2a5964.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.cityofhenderson.com/Home/Components/FacilityDirectory/FacilityDirectory/242/752",
      "poi_directions_map_url": "https://maps.google.com/?cid=12581504458996682912&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "36.0312039",
      "poi_longitude": "-114.9545136",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 702-267-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcwvU4DWyIARoJB9UqV7mq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8557dd84-5cae-4739-a948-b90c59fcff4d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Cornerstone Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 Wigwam Pkwy, Henderson, NV 89074, USA",
      "poi_short_description": "Clean, serene lakeside green space offering a farmers market, hiking and a workout area.",
      "poi_long_description": "People say this park offers walking trails, a lake, and opportunities for jogging, picnicking, and viewing wildlife. They highlight the peaceful and relaxing vibe, and the well-maintained facilities, including clean restrooms, picnic areas, and sports courts. They also like the ample parking and the presence of a farmers market on Saturdays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-4432-75ff-908d-21d9bf8ad6b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4432-75ff-908d-21d9bf8ad6b5",
        "storage_key": "property/6767906449166430/019d02c8-4432-75ff-908d-21d9bf8ad6b5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cityofhenderson.com/Home/Components/FacilityDirectory/FacilityDirectory/218/752",
      "poi_directions_map_url": "https://maps.google.com/?cid=14877685718135244108&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornerstone-park",
      "poi_latitude": "36.03547",
      "poi_longitude": "-115.0554934",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-267-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJISkU5aXRyIARTIVa1VUoeM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3ff12a33-6c53-4178-80f5-f8897a7cc184",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Ethel M Botanical Cactus Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 Cactus Garden Dr, Henderson, NV 89014, USA",
      "poi_short_description": "Botanical garden featuring more than 300 species of cacti and a holiday light display.",
      "poi_long_description": "People say this botanical garden offers a wide variety of cacti, a chocolate factory with delicious chocolates, and a festive holiday light display. They highlight the peaceful and beautiful atmosphere, the well-maintained and accessible paths, and the informative signage. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-462f-72de-8f30-3ecf37a91649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-462f-72de-8f30-3ecf37a91649",
        "storage_key": "property/6767906449166430/019d02c8-462f-72de-8f30-3ecf37a91649.webp",
        "width": 1280,
        "height": 1042
      },
      "poi_business_url": "https://www.ethelm.com/botanical-cactus-garden",
      "poi_directions_map_url": "https://maps.google.com/?cid=16052443012251310256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ethel-m-botanical-cactus-garden",
      "poi_latitude": "36.0739178",
      "poi_longitude": "-115.0718627",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-438-4356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-sepBLQyIARsNhwwt67xd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_ee4ec863-9e09-4427-8736-69eaf8aa9354",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Clark County Wetlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7050 Wetlands Park Ln, Las Vegas, NV 89122, USA",
      "poi_short_description": "Tranquil park with marshland, birdlife, and paved and dirt paths for hiking and biking.",
      "poi_long_description": "People say this park offers beautiful bike trails, hiking paths, and opportunities for bird watching and wildlife viewing. They highlight the peaceful and tranquil atmosphere, and the well-maintained trails and picnic shelters. They also like the informative visitor center and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-468a-71ae-af95-e3779416216a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-468a-71ae-af95-e3779416216a",
        "storage_key": "property/6767906449166430/019d02c8-468a-71ae-af95-e3779416216a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clarkcountynv.gov/government/departments/parks___recreation/wetlands_park/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=3267682993093179764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-county-wetlands-park",
      "poi_latitude": "36.1011164",
      "poi_longitude": "-115.0231015",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 702-455-7522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL55XYnPayIARdHnniV4kWS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9a6c6dd4-a4c4-42ee-a379-e1fe51e4d7d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Harry Reid International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5757 Wayne Newton Blvd, Las Vegas, NV 89119, USA",
      "poi_short_description": "Airport serving the Las Vegas area, with more than 1,200 slot machines.",
      "poi_long_description": "Visitors say this airport is easy to navigate and has quick and efficient TSA PreCheck lines, as well as a variety of amenities including charging stations, slot machines, and dining options. They also highlight the friendly and helpful staff, and the clean and modern facilities.\n\nSome reviews mention the rental car shuttle can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-4686-775f-bde8-87c3ef34b947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4686-775f-bde8-87c3ef34b947",
        "storage_key": "property/6767906449166430/019d02c8-4686-775f-bde8-87c3ef34b947.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.harryreidairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5121535212920249886&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-reid-international-airport",
      "poi_latitude": "36.08309070000001",
      "poi_longitude": "-115.1482238",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-261-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-6015-741d-9e49-85cff9d248be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-6015-741d-9e49-85cff9d248be",
        "storage_key": "property/6767906449166430/019d02c8-6015-741d-9e49-85cff9d248be.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZwEH5_FyIARHh7EHiRZE0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_d52208d0-ab80-42bb-8cd0-ce20a2d3a850",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Pacific Dental Services Henderson Support Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2460 Paseo Verde Pkwy #145, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-4d32-70ab-883c-5ab6801905cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4d32-70ab-883c-5ab6801905cc",
        "storage_key": "property/6767906449166430/019d02c8-4d32-70ab-883c-5ab6801905cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pacificdentalservices.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18390639736365976718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-dental-services-henderson-support-office",
      "poi_latitude": "36.0191855",
      "poi_longitude": "-115.0932073",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-820-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7RNdeDRyIARjgxHBmetOP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_546d016f-2c82-40eb-9223-a33a39e0bc0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Henderson City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "240 S Water St, Henderson, NV 89015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5146-76f8-87b6-0264c79fc191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5146-76f8-87b6-0264c79fc191",
        "storage_key": "property/6767906449166430/019d02c8-5146-76f8-87b6-0264c79fc191.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.cityofhenderson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6451909789068175000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henderson-city-hall",
      "poi_latitude": "36.0298639",
      "poi_longitude": "-114.981711",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-267-2323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-6016-714f-8bd2-af87ec5d0147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-6016-714f-8bd2-af87ec5d0147",
        "storage_key": "property/6767906449166430/019d02c8-6016-714f-8bd2-af87ec5d0147.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5cChaPWyIARmCZG_MTJiVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_68baea56-112f-4fe5-9e31-e09acbf688a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Konami Gaming Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "585 Konami Cir, Las Vegas, NV 89119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-538f-71ec-a4e4-5fe0ebbcb088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-538f-71ec-a4e4-5fe0ebbcb088",
        "storage_key": "property/6767906449166430/019d02c8-538f-71ec-a4e4-5fe0ebbcb088.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.konamigaming.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17750727512982788762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "konami-gaming-inc",
      "poi_latitude": "36.0706918",
      "poi_longitude": "-115.1526941",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-616-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8uTEIbFyIARmpoXLKBAV_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6b852aea-4d45-46f8-b8b1-cec418a984f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Google",
      "poi_type": "Major Employers & Offices",
      "poi_address": "560 W Warm Springs Rd, Henderson, NV 89011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5488-727e-8694-29df3c19d250.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5488-727e-8694-29df3c19d250",
        "storage_key": "property/6767906449166430/019d02c8-5488-727e-8694-29df3c19d250.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.google.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4337496446571716113&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google",
      "poi_latitude": "36.0561599",
      "poi_longitude": "-115.009056",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8ZePInRyIARER5tgAniMTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_76a04629-1a4f-4751-a994-f91a1ffae0b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "MGM Resorts International Career Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "980 Kelly Johnson Dr, Las Vegas, NV 89119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5463-748a-8246-9f24e2557000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5463-748a-8246-9f24e2557000",
        "storage_key": "property/6767906449166430/019d02c8-5463-748a-8246-9f24e2557000.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mgmresortscareers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12215340498375626626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mgm-resorts-international-career-center",
      "poi_latitude": "36.0712072",
      "poi_longitude": "-115.1420416",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 877-880-0880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJATP4A4HFyIARgk8fsHabhak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c3993e36-950b-4ca9-b12c-5b65e4f4ab75",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "594 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_long_description": "People say this restaurant offers a wide variety of delicious, freshly made food, with popular items like the candied bacon, bison meatloaf, and burgers. They also highlight the reasonable prices, generous portions, and dog-friendly patio with a cozy fire pit. Guests mention the staff are consistently friendly, attentive, and provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-6279-70cf-8fb7-4735ae96e334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-6279-70cf-8fb7-4735ae96e334",
        "storage_key": "property/6767906449166430/019eb2a1-6279-70cf-8fb7-4735ae96e334.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lazydogrestaurants.com/pages/henderson-nv",
      "poi_directions_map_url": "https://maps.google.com/?cid=7709782719909055287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "36.0616533",
      "poi_longitude": "-115.0457258",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-727-4772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUxecqrRyIARN8ufG4mm_mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_daff9a14-5832-43a8-aa73-4104c53f7410",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "MISSION BBQ",
      "poi_type": "Restaurants",
      "poi_address": "375 N Stephanie St suite 100A, Henderson, NV 89014, USA",
      "poi_short_description": "Casual chain featuring BBQ & classic sides, plus memorabilia honoring soldiers & first responders.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, pulled pork, and ribs, and offers a variety of sauces and sides, including baked beans, mac and cheese, and collard greens. They also highlight the friendly staff, quick service, and patriotic atmosphere.\n\nOther reviews mention the food can be salty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-6032-750a-b2f2-27909103dc15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-6032-750a-b2f2-27909103dc15",
        "storage_key": "property/6767906449166430/019eb2a1-6032-750a-b2f2-27909103dc15.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://mission-bbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1113648362407232301&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mission-bbq",
      "poi_latitude": "36.0556923",
      "poi_longitude": "-115.0468996",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-835-6822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ995Y0pXRyIARLYP6BUl5dA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_5325a2fe-403a-4f6b-bef6-0ff6b3b781ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Meráki Greek Grill",
      "poi_type": "Restaurants",
      "poi_address": "249 N Stephanie St Ste 150, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Greek restaurant serves delicious falafel pitas, gyros, and burgers, and the food is fresh and flavorful. They highlight the generous portions and good value for the price. They also like the clean and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-5f59-715d-84e8-b75be762d75e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-5f59-715d-84e8-b75be762d75e",
        "storage_key": "property/6767906449166430/019eb2a1-5f59-715d-84e8-b75be762d75e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.merakigreekgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7470095423370579580&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "merki-greek-grill",
      "poi_latitude": "36.0447967",
      "poi_longitude": "-115.0471822",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-586-8584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9rlDyXRyIARfE5GlDUcq2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_a1e984a8-5c3c-4599-9e9f-e50eadbd76f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Thailicious",
      "poi_type": "Restaurants",
      "poi_address": "19 S Stephanie St Ste. 160, Henderson, NV 89012, USA",
      "poi_short_description": "Low-key, unfussy stop for the usual Thai standards such as soups, curries, salads, tea & coffee.",
      "poi_long_description": "People say this Thai restaurant offers delicious green curry, pad thai, and other dishes, with generous portions and fresh ingredients. They highlight the affordable lunch specials and the fast, efficient service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-5e2e-71bd-8d25-d2a53ac69292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-5e2e-71bd-8d25-d2a53ac69292",
        "storage_key": "property/6767906449166430/019eb2a1-5e2e-71bd-8d25-d2a53ac69292.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.thailiciousvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14380757407533029954&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thailicious",
      "poi_latitude": "36.0281056",
      "poi_longitude": "-115.0483278",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-489-9441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3THTjp_RyIARQtoSbau2ksc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_eb367934-3e91-4776-b2af-62527eba59d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Storming Crab",
      "poi_type": "Restaurants",
      "poi_address": "573 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "Casual eatery featuring seafood boils, fried baskets and Cajun eats, plus a bar.",
      "poi_long_description": "Guests consistently praise this seafood restaurant for its fun atmosphere and reasonable prices. The friendly staff and excellent all-you-can-eat option are also frequently highlighted.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-5df6-7695-87bc-6187ef6f74c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-5df6-7695-87bc-6187ef6f74c6",
        "storage_key": "property/6767906449166430/019eb2a1-5df6-7695-87bc-6187ef6f74c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stormingcrabhenderson.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13690564211240434492&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "storming-crab",
      "poi_latitude": "36.0606752",
      "poi_longitude": "-115.0467557",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-547-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bKHkqTRyIARPHupSZ2n_r0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ca77cf23-a470-4e9a-8445-686afcfe8d9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "BabyStacks Cafe - Henderson",
      "poi_type": "Restaurants",
      "poi_address": "675 Mall Ring Cir Ste a, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "Customers consistently praise this cafe for its wide variety of delicious breakfast offerings, including pancakes and omelets. The friendly and attentive staff, reasonable prices, and clean environment are also frequently highlighted.\n\nSome reviews mention the food can be burnt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2a1-5e9f-7399-8879-9cfbcd0d2693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2a1-5e9f-7399-8879-9cfbcd0d2693",
        "storage_key": "property/6767906449166430/019eb2a1-5e9f-7399-8879-9cfbcd0d2693.webp",
        "width": 1099,
        "height": 853
      },
      "poi_business_url": "https://www.babystackscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7723150913360261154&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "babystacks-cafe---henderson",
      "poi_latitude": "36.0650423",
      "poi_longitude": "-115.045598",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-458-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a1-7021-af90-d1d045ab53da",
        "storage_key": "property/6767906449166430/019d02c8-58a1-7021-af90-d1d045ab53da.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhT7SDADRyIARInCSMdYkLms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_683dab15-89fa-4878-94e7-2f1c2f882a84",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "605 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this department store for being clean and well-stocked with a wide variety of items, including a good grocery selection and good exclusive member deals. They also appreciate the fast self-checkout and spotless restrooms, alongside the friendly staff.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2ce-9709-7474-887d-97f9a10ebeda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2ce-9709-7474-887d-97f9a10ebeda",
        "storage_key": "property/6767906449166430/019eb2ce-9709-7474-887d-97f9a10ebeda.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/henderson-stephanie-street/680",
      "poi_directions_map_url": "https://maps.google.com/?cid=16899057105053649488&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.06474499999999",
      "poi_longitude": "-115.0482672",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-451-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-589d-75f3-8b73-a349cb9aabcc",
        "storage_key": "property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM82NS1_QyIARUIrD6eaCheo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7a0492a8-0404-46ef-b630-6d29e392bc45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "480 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Visitors say this store is clean and organized, offering a great selection and variety of merchandise. They also highlight the friendly and helpful staff, mentioning it's a good place to find deals.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2ce-95dd-7039-a292-f52411ea5b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2ce-95dd-7039-a292-f52411ea5b7b",
        "storage_key": "property/6767906449166430/019eb2ce-95dd-7039-a292-f52411ea5b7b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=12555466253364431869&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "36.0582846",
      "poi_longitude": "-115.0438017",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-435-7027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-589d-75f3-8b73-a349cb9aabcc",
        "storage_key": "property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4YJBDPjQyIAR_QsxJQn6Pa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_472d098e-2e87-4c75-bdbd-3279c72fee1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "579 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "Chain department store with men’s and women’s clothing plus shoes and accessories.",
      "poi_long_description": "Customers consistently praise this store for its extensive selection of quality merchandise, including designer items, and the opportunity to find good deals. They also appreciate the friendly staff and the clean, organized shopping environment.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2ce-95e8-7530-94d5-aab744dbb8e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2ce-95e8-7530-94d5-aab744dbb8e2",
        "storage_key": "property/6767906449166430/019eb2ce-95e8-7530-94d5-aab744dbb8e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/nv/henderson/579-n-stephanie-st?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=376&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=17690314007014640116&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "36.0609213",
      "poi_longitude": "-115.0483185",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-948-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-589d-75f3-8b73-a349cb9aabcc",
        "storage_key": "property/6767906449166430/019d02c8-589d-75f3-8b73-a349cb9aabcc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ8ekKPbQyIAR9Ik5sdyegPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c5224751-46eb-4c97-bc0c-4dc841a43c59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Smith's Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "560 N Stephanie St, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this grocery store offers a huge variety of fresh produce, deli items, and household goods, with a well-planned layout. They also highlight the clean environment, reasonable prices, and helpful staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2ce-95bf-74ed-82f0-102f24916de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2ce-95bf-74ed-82f0-102f24916de8",
        "storage_key": "property/6767906449166430/019eb2ce-95bf-74ed-82f0-102f24916de8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/nv/henderson/galleria-commons-smiths/706/00303?cid=loc_70600303_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16985018556805146584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smiths-marketplace",
      "poi_latitude": "36.0603937",
      "poi_longitude": "-115.0437284",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-728-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a4-705e-9586-055ee9dbfc61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a4-705e-9586-055ee9dbfc61",
        "storage_key": "property/6767906449166430/019d02c8-58a4-705e-9586-055ee9dbfc61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_jpaADRyIAR2OfJDWPotus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f2a61ce4-419f-419e-9fdc-c2eb7c471a8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Regal Sunset Station",
      "poi_type": "Entertainment",
      "poi_address": "1301 W Sunset Rd, Henderson, NV 89014, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Reviewers praise this movie theater for its comfortable reclining seats, good sound system, and extensive variety of movies and concessions. The friendly and helpful staff are also frequently highlighted.\n\nSome reviews mention the theaters can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-dd55-7354-a42f-bee459c05df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2d7-dd55-7354-a42f-bee459c05df5",
        "storage_key": "property/6767906449166430/019eb2d7-dd55-7354-a42f-bee459c05df5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-sunset-station-0838?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5291712537978916700&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-sunset-station",
      "poi_latitude": "36.061226",
      "poi_longitude": "-115.04178",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-f0d4-70c6-a100-7766075eb764.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb2d7-f0d4-70c6-a100-7766075eb764",
        "storage_key": "property/6767906449166430/019eb2d7-f0d4-70c6-a100-7766075eb764.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaI3VPfQyIARXM-2P4Twb0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_96c5d340-7b11-4158-92c6-8f186cb5b036",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Sunset Station Strike Zone",
      "poi_type": "Entertainment",
      "poi_address": "1301 W Sunset Rd, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this bowling alley offers a fun experience with many lanes and a spacious layout. They highlight the affordable pricing, especially for senior deals, and the clean, well-maintained facilities. They also like the friendly and helpful staff, and the delicious food and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-dfb9-70fc-8ec3-a4bc2df5f140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2d7-dfb9-70fc-8ec3-a4bc2df5f140",
        "storage_key": "property/6767906449166430/019eb2d7-dfb9-70fc-8ec3-a4bc2df5f140.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sunsetstation.com/see-and-do/strike-zone/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15061282578698652727&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunset-station-strike-zone",
      "poi_latitude": "36.0599954",
      "poi_longitude": "-115.04074389999998",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-547-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaI3VPfQyIARN8wcDbVsBNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_96d4d743-5305-4aa1-ab08-482d4bf13e6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Flip N Out Xtreme - Henderson",
      "poi_type": "Entertainment",
      "poi_address": "1235 W Warm Springs Rd, Henderson, NV 89014, USA",
      "poi_short_description": "Bouncing, arcade place featuring trampolines, dodgeball and laser tag, as well as party rooms.",
      "poi_long_description": "People say this trampoline park offers a wide variety of activities, including jumping, basketball, dodgeball, laser tag, and a rock wall, with separate play areas for younger children. They also highlight the clean and well-maintained facility, attentive staff, and reasonable prices.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-de1b-7158-af95-3b5aebcd1394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2d7-de1b-7158-af95-3b5aebcd1394",
        "storage_key": "property/6767906449166430/019eb2d7-de1b-7158-af95-3b5aebcd1394.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.flipnoutxtreme.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12857768548409800742&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flip-n-out-xtreme---henderson",
      "poi_latitude": "36.053751",
      "poi_longitude": "-115.0395439",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-579-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3GWNPzQyIARJvgnFF_4b7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_7ae01eaf-1610-40dd-bd3e-7cd0ae909f2a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Kids Empire Henderson",
      "poi_type": "Entertainment",
      "poi_address": "225 N Stephanie St, Henderson, NV 89074, USA",
      "poi_short_description": "Colorfully decorated indoor venue featuring slides, a jungle gym, and an obstacle course, for ages up to 12.",
      "poi_long_description": "People say this indoor playground offers a huge, clean play area with slides, obstacle courses, and a dedicated toddler zone, keeping kids entertained for hours. They also highlight the reasonable all-day pass prices, allowing re-entry, and the comfortable seating for adults with clear views of the play areas. The staff are consistently described as friendly, helpful, and attentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-de23-715d-8f85-ab307ac52003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2d7-de23-715d-8f85-ab307ac52003",
        "storage_key": "property/6767906449166430/019eb2d7-de23-715d-8f85-ab307ac52003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kidsempire.com/park/henderson?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6989971424243547307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kids-empire-henderson",
      "poi_latitude": "36.0434932",
      "poi_longitude": "-115.0481746",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-470-1833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZboDVfRyIARq_wq1PldAWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_d882aa5a-3572-45e9-be80-3461202767bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Uptown Jungle Fun Park",
      "poi_type": "Entertainment",
      "poi_address": "27 S Stephanie St, Henderson, NV 89012, USA",
      "poi_short_description": "Children's entertainment center with climbing walls, trampolines, slides, and other energetic diversions.",
      "poi_long_description": "Visitors consistently praise this indoor playground for its wide variety of activities, such as trampolines, climbing walls, and obstacle courses, alongside a spacious toddler area. They also highlight the friendly staff and affordable pricing.\n\nSome reviews mention the facility can be neglected.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019eb2d7-dc91-735b-9015-2ce153366e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2d7-dc91-735b-9015-2ce153366e66",
        "storage_key": "property/6767906449166430/019eb2d7-dc91-735b-9015-2ce153366e66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://henderson.uptownjungle.com/indoor-playground-trampoline-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18014885099416041177&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uptown-jungle-fun-park",
      "poi_latitude": "36.0282095",
      "poi_longitude": "-115.0495603",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-935-9833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBY4TTa3RyIAR2bYrDI26Afo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_0d1b5bfa-2cbf-49e8-8826-bb9ae315fa88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Ocean Spray Cranberries, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 American Pacific Dr, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-cee8-74ca-a88d-667642153031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-cee8-74ca-a88d-667642153031",
        "storage_key": "property/6767906449166430/019f150a-cee8-74ca-a88d-667642153031.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.oceanspray.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16357286770288167664&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ocean-spray-cranberries-inc",
      "poi_latitude": "36.0404306",
      "poi_longitude": "-115.0434851",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 800-662-3263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0i4uSHRyIAR8Ao5KKfBAOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a929adbc-485e-4ac9-b254-9cf70b727256",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "MGM Grand Monorail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3799 S Las Vegas Blvd, Las Vegas, NV 89109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-d0bf-7259-ad1e-2d88e93bcd38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-d0bf-7259-ad1e-2d88e93bcd38",
        "storage_key": "property/6767906449166430/019f150a-d0bf-7259-ad1e-2d88e93bcd38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lvmonorail.com/stations/mgm-grand/?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14622497484122495381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mgm-grand-monorail-station",
      "poi_latitude": "36.1024374",
      "poi_longitude": "-115.1677924",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-699-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c00-721f-9dc9-23e54bbb5a4f",
        "storage_key": "property/6767906449166430/019d02c8-5c00-721f-9dc9-23e54bbb5a4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTUvQ5srFyIARlRkqDv2L7co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_8e1eee25-a6c9-46ce-a1d8-ee620b3bc338",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "RTC Bus Stop - St. Rose & Paseo Verde",
      "poi_type": "Transportation & Transit",
      "poi_address": "St. Rose Pkwy & Paseo Verde Pkwy, Henderson, NV 89074",
      "poi_short_description": "RTC Southern Nevada bus stop serving local routes",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f1d4f07-7d47-4bb2-bdf7-a8f13e3217ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "RTC Bus Stop - American Pacific & Stephanie",
      "poi_type": "Transportation & Transit",
      "poi_address": "American Pacific Dr & Stephanie St, Henderson, NV 89074",
      "poi_short_description": "Convenient RTC bus stop serving the Gibson Springs business district",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_12b57ee6-185a-4332-adb0-962d2ad25571",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "RTC Bus Stop - Warm Springs & Stephanie",
      "poi_type": "Transportation & Transit",
      "poi_address": "Warm Springs Rd & Stephanie St, Henderson, NV 89014",
      "poi_short_description": "Major RTC stop with multiple bus connections",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04c66b22-c477-422b-876a-d84acf3c9048",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "RTC Bus Stop - Green Valley & Paseo Verde",
      "poi_type": "Transportation & Transit",
      "poi_address": "Green Valley Pkwy & Paseo Verde Pkwy, Henderson, NV 89074",
      "poi_short_description": "Busy RTC transit stop providing access to Green Valley Ranch and surrounding commercial areas",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_24a9ebe6-0454-4c2f-82c8-158f162fa2d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Whitney Mesa Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1990 Patrick Ln, Henderson, NV 89014, USA",
      "poi_short_description": "Bicycle and hiking paths, plus a picnic space and views from a hill and the mesa summit.",
      "poi_long_description": "Visitors say this nature area offers amazing views and numerous trails suitable for different physical levels. They also highlight the shaded picnic areas and restrooms with water fountains. Others like the opportunity for bird watching and plane spotting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-cd3d-730c-9307-92031a026135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-cd3d-730c-9307-92031a026135",
        "storage_key": "property/6767906449166430/019f150a-cd3d-730c-9307-92031a026135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofhenderson.com/Home/Components/FacilityDirectory/FacilityDirectory/327/752",
      "poi_directions_map_url": "https://maps.google.com/?cid=9568050537870983200&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whitney-mesa-nature-preserve",
      "poi_latitude": "36.0770834",
      "poi_longitude": "-115.0624421",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-267-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-5c34-718e-a608-c223f5963ca9",
        "storage_key": "property/6767906449166430/019d02c8-5c34-718e-a608-c223f5963ca9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3yER3DQyIARIADJPkWLyIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_78c9599b-e02f-4885-b1aa-a2c201ed596f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Selma F Bartlett Elementary",
      "poi_type": "Education",
      "poi_address": "1961 Wigwam Pkwy, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-cce0-76de-a2a7-1e7089c8e120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-cce0-76de-a2a7-1e7089c8e120",
        "storage_key": "property/6767906449166430/019f150a-cce0-76de-a2a7-1e7089c8e120.webp",
        "width": 864,
        "height": 1152
      },
      "poi_business_url": "https://www.selmabartlett.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16943247331314701984&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "selma-f-bartlett-elementary",
      "poi_latitude": "36.0276659",
      "poi_longitude": "-115.0710167",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-799-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbZg1pMDRyIARoBaZvK2BIus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_395a98d5-9414-4201-93a8-9d52b252cdf3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Greenspun Junior High School",
      "poi_type": "Education",
      "poi_address": "140 N Valle Verde Dr Unit 150, Henderson, NV 89074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-d398-73b9-8b86-b84e731017ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-d398-73b9-8b86-b84e731017ed",
        "storage_key": "property/6767906449166430/019f150a-d398-73b9-8b86-b84e731017ed.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.greenspunjhs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11471960706717532432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greenspun-junior-high-school",
      "poi_latitude": "36.0352653",
      "poi_longitude": "-115.0660573",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-799-0920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3ZKXD0rQyIAREEEjUXuXNJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0fbd7818-ee64-4949-a226-4fca51443efd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Green Valley High School",
      "poi_type": "Education",
      "poi_address": "460 N Arroyo Grande Blvd, Henderson, NV 89014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-ccce-7719-a19b-7add7ac106e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-ccce-7719-a19b-7add7ac106e7",
        "storage_key": "property/6767906449166430/019f150a-ccce-7719-a19b-7add7ac106e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.greenvalleyhs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13195434245598010414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "green-valley-high-school",
      "poi_latitude": "36.057796",
      "poi_longitude": "-115.0533643",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-799-0950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9UHPb1rQyIARLtzksYiZH7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_61ff2f83-15ff-4194-b0f1-98aaa51698ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "poi_name": "Paseo Verde Library",
      "poi_type": "Education",
      "poi_address": "280 S Green Valley Pkwy, Henderson, NV 89012, USA",
      "poi_short_description": "Spacious library (part of a city system) featuring multiple reading areas, a coffee shop and children's programs.",
      "poi_long_description": "People say this public library offers a good selection of books, including a comprehensive children's section, and a variety of resources. They highlight the quiet spaces for studying, reading, and reflecting, and the convenient coffee shop with vegan pastries. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019f150a-d008-7746-9b11-d20706833df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-d008-7746-9b11-d20706833df5",
        "storage_key": "property/6767906449166430/019f150a-d008-7746-9b11-d20706833df5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hendersonlibraries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17418676902402137083&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paseo-verde-library",
      "poi_latitude": "36.0174533",
      "poi_longitude": "-115.0801182",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 702-707-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-58a3-7312-8108-d6c1e5522738",
        "storage_key": "property/6767906449166430/019d02c8-58a3-7312-8108-d6c1e5522738.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscymxOjRyIAR-xv7yFqSu_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b3e283138cec5926a12f808f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9b6368a3033453c38801dc79",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5ee6507e46380cda140545a0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5b523e6cd6922abe861a9643",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9b492ff0da3c0673c42dd775",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c1e82d8f1ce84c812c81c069",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_3eabf4d3-829f-4147-bdf0-71daa4a889bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "rating": "5.0",
      "name": "Alana Brianee",
      "text": "I just moved in 2 days ago and Monica made my process very smooth 😊 A beautiful location with updated appliances even the classic homes are modern and clean . Beautiful community, Valet trash , calm and an amazing apartment complex . you definitely should move here it’s the best apartment to live in Henderson in my opinion 🫶",
      "date": "2025-04-24",
      "title": ""
    },
    {
      "id": "custom_7c497e3a-6388-4a15-a905-b57cb1e993fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "rating": "5.0",
      "name": "Lat Has",
      "text": "From the moment my daughter found Cornerstone Park Apartments for me, my experience has been nothing short of excellent. A big reason for that is Cynthia—she has been amazing from day one. She’s incredibly professional, friendly, and always willing to help with anything I needed. She made sure everything was running smoothly, Cynthia goes above and beyond. It’s clear she genuinely cares about the residents and takes pride in her work at this community. Thanks to her, I’ve felt welcomed and supported every step of the way. Highly recommend Cornerstone Park Apartments—especially with someone like Cynthia on the team!",
      "date": "2025-06-13",
      "title": ""
    },
    {
      "id": "custom_a56bcd24-8cfd-4865-860a-3088b7fea622",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "rating": "4.0",
      "name": "Harmon Jennifer",
      "text": "I love the location of this complex! This was the selling point for me. For the most part it was pretty quiet with the exception of a Harley driver and a loud Camaro. The rent & fee increases are the reason why I left. You can rent a house for as much as you’ll pay for the 2 bedroom. Thank you for 2 great years!",
      "date": "2025-09-07",
      "title": ""
    },
    {
      "id": "custom_cd03c0d2-e610-4f80-bbe9-de6ec40443f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "rating": "5.0",
      "name": "Marina Youssef",
      "text": "Cornerstone Apartments has an incredibly welcoming and friendly atmosphere, thanks to its amazing staff (Cynthia, Jennifer and Monica) and maintenance team. From the moment you arrive, the office staff greets you with warmth and professionalism, always ready to assist with any questions or concerns. The maintenance team is equally outstanding—quick to respond, efficient, and genuinely caring about the residents' comfort. It’s clear that they take pride in keeping the community well-maintained and ensuring everyone feels at home. Living here has been a wonderful experience, and the friendly environment makes it even better!",
      "date": "2025-03-11",
      "title": ""
    },
    {
      "id": "custom_44ba40e7-35eb-43d7-bc91-c93d5eb49b76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "rating": "5.0",
      "name": "Rebecca Nagel",
      "text": "As a vendor, I've seen a lot of apartment communities, but this one stands above the rest!\n\nNot only is this property stunning and immaculately clean, but the onsite team is also one of the best I've ever worked with. Their professionalism and clear communication make collaborating with them a breeze. If you're looking for a top-notch apartment community, this is the one for you!",
      "date": "2024-12-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_afcc7570-e431-4e11-be68-06ec8531bdf1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c9-6cc1-764d-b75c-a3abe470f3c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and bedroom of an apartment",
        "public_id": "019d02c9-6cc1-764d-b75c-a3abe470f3c9",
        "storage_key": "property/6767906449166430/019d02c9-6cc1-764d-b75c-a3abe470f3c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 947 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cmczNM1yyaF"
    },
    {
      "id": "custom_4c7bf5c3-caf4-4598-b1c9-54ce973c7cd0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c9-6c8e-73a9-84e9-0294075647c8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lounge area with comfortable seating, a large wooden coffee table, and unique overhead lighting.",
        "public_id": "019d02c9-6c8e-73a9-84e9-0294075647c8",
        "storage_key": "property/6767906449166430/019d02c9-6c8e-73a9-84e9-0294075647c8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fVz4BVfN4Sj"
    },
    {
      "id": "custom_ee02ba3f-e3e6-49da-84ee-ad418828030f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c9-6d0c-773f-ba7b-dc338822eb9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, rowing machines, and free weights.",
        "public_id": "019d02c9-6d0c-773f-ba7b-dc338822eb9b",
        "storage_key": "property/6767906449166430/019d02c9-6d0c-773f-ba7b-dc338822eb9b.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vbHb2outN7n"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfba-948d-718c-a53b-f7cdbede51a6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-cornerstone-park-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "dog-park-apartments-henderson-nv-cornerstone",
      "search_query": "dog park apartments Henderson NV",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Henderson, NV",
      "h2_subtitle": "Explore Dog Park Apartments in the vibrant city of Henderson, NV. Find a pet-friendly community that welcomes your furry friends.",
      "page_copy": "At Cornerstone Park, we believe pets are part of the family. Conveniently located in Henderson, NV, our community offers access to numerous outdoor spaces, making it a prime choice for those seeking dog park apartments. With serene walking trails and inviting picnic areas, both you and your dog will find joy in the natural surroundings.\n\nLiving in our pet-friendly community not only means enjoying modern apartment layouts but also taking advantage of our close-knit neighborhood vibe. Close to Gibson Springs, our corner of Clark County includes green spaces perfect for outdoor adventures with your pet. Come explore why Cornerstone Park is a top choice for dog lovers in Henderson.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Henderson, NV",
      "seo_description": "Discover pet-friendly apartments in Henderson, NV with access to dog parks and outdoor adventures. Cornerstone Park welcomes you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-gibson-springs-cornerstone",
      "search_query": "in unit laundry apartments Gibson Springs",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Gibson Springs",
      "h2_subtitle": "Discover apartments with in-unit laundry in Gibson Springs. Enjoy the convenience and modern living at Cornerstone Park.",
      "page_copy": "Experience the convenience of in-unit laundry at Cornerstone Park, located in the charming Gibson Springs neighborhood. Our modern apartments are designed to simplify your lifestyle, offering features like in-unit washers and dryers to make everyday life more comfortable. With styles ranging from one to three-bedroom floor plans, you can find the perfect space to call home.\n\nBeyond the convenience inside your apartment, our Henderson location offers an array of amenities, including gated access, double vanities, and a recreational gameroom. Whether you're spending a day indoors or exploring our serene walking trails, living at Cornerstone Park means having all the essentials right at your fingertips. Upgrade to the ultimate blend of comfort and practicality today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Gibson Springs",
      "seo_description": "Explore Gibson Springs apartments with in-unit laundry at Cornerstone Park, offering modern living in Henderson, NV.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "rentals-with-air-conditioning-clark-county-cornerstone",
      "search_query": "rentals with air conditioning Clark County",
      "category": "Amenity",
      "h1_title": "Rentals with Air Conditioning in Clark County",
      "h2_subtitle": "Explore rentals with air conditioning in vibrant Clark County. Enjoy comfort and convenience at Cornerstone Park in Henderson, NV.",
      "page_copy": "Stay cool and comfortable with air-conditioned rentals at Cornerstone Park, nestled within the heart of Clark County. Our community offers a variety of modern apartments where central air conditioning is just one of many features designed to enhance your living experience. Whether you choose a cozy one-bedroom or a spacious three-bedroom floor plan, you'll enjoy the perfect climate all year round.\n\nLocated in the bustling area of Henderson, NV, our apartments provide easy access to essential amenities, including controlled access, a gameroom for relaxation, and serene walking trails. Experience the best of Clark County living with the assurance of returning home to a refreshing, air-conditioned retreat at Cornerstone Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals with Air Conditioning in Clark County",
      "seo_description": "Find air-conditioned rentals in Clark County at Cornerstone Park, Henderson. Enjoy comfort and modern living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-with-pool-in-henderson-cornerstone",
      "search_query": "apartments with pool in Henderson",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Henderson",
      "h2_subtitle": "Discover apartments with a pool in Henderson, NV at Cornerstone Park. Enjoy leisure and luxury in our vibrant community.",
      "page_copy": "Dive into leisure at Cornerstone Park, where our Henderson apartments feature an inviting pool ideal for relaxation and recreation. Our community provides a serene oasis for residents to unwind, complete with stunning poolside areas perfect for socializing or enjoying a sunny afternoon. Experience hassle-free leisure right at your doorstep in one of our stylish one, two, or three-bedroom apartments.\n\nBeyond our pool, Cornerstone Park offers an array of amenities that enhance your living experience, like gated access and double vanities, all in the welcoming neighborhood of Gibson Springs. Enjoy the perfect mix of modern comfort and outdoor fun, making our community in Henderson, NV, an exceptional place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Henderson, NV",
      "seo_description": "Find your perfect home at Cornerstone Park, Henderson, NV, offering apartments with a pool and modern amenities for a luxurious lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-dishwasher-89074-cornerstone",
      "search_query": "luxury apartments with dishwasher 89074",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher in 89074",
      "h2_subtitle": "Explore luxury living with a dishwasher in the 89074 area. Cornerstone Park offers modern comforts and upscale amenities in Henderson, NV.",
      "page_copy": "Experience the epitome of luxury living at Cornerstone Park, where our sophisticated apartments in the 89074 area come equipped with modern dishwashers. Our one, two, and three-bedroom floor plans are meticulously designed to offer convenience and elegance, embodying the finest in contemporary living. Say goodbye to manual dishwashing and enjoy more free time at our lavish community.\n\nLocated in Henderson's sought-after Gibson Springs neighborhood, Cornerstone Park is not just about style but also about superior amenities. Enjoy double vanities and a gameroom, alongside controlled access and inviting outdoor spaces. Relish the combination of comfort and practicality in a setting that feels like home the moment you step inside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher in 89074",
      "seo_description": "Find luxury apartments with a dishwasher in Henderson's 89074 area at Cornerstone Park. Enjoy modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-henderson-nv-cornerstone",
      "search_query": "1 bedroom apartments henderson nv",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Henderson, NV",
      "h2_subtitle": "Discover stylish 1 bedroom apartments in Henderson, NV at Cornerstone Park. Experience modern living in a vibrant community.",
      "page_copy": "Welcome to Cornerstone Park, where our elegant one-bedroom apartments redefine modern living in Henderson, NV. Ideal for singles or couples, these thoughtfully designed spaces offer all the comforts of home with a touch of luxury. Each unit is equipped with modern fixtures and finishes, making it a perfect retreat after a busy day.\n\nLocated in the welcoming neighborhood of Gibson Springs, our community boasts more than just beautiful interiors. Enjoy access to superb amenities such as a gameroom and gated entrances, providing a blend of leisure and security. Choose Cornerstone Park for your one-bedroom haven in the heart of Henderson, where lifestyle and convenience go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Henderson, NV",
      "seo_description": "Explore Cornerstone Park's stylish 1 bedroom apartments in Henderson, NV. Enjoy modern amenities and vibrant living in Gibson Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-gibson-springs-cornerstone",
      "search_query": "2 bedroom apartments gibson springs",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Gibson Springs",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Gibson Springs at Cornerstone Park. Enjoy the perfect blend of comfort and style.",
      "page_copy": "Cornerstone Park offers spacious 2-bedroom apartments in the desirable Gibson Springs neighborhood, perfect for families or roommates seeking contemporary living in a serene setting. Each apartment offers a harmonious blend of style and function, featuring ample living space and modern amenities like double vanities, making everyday life more comfortable.\n\nOur community in Henderson, NV, not only provides exceptional accommodations but also includes a variety of amenities such as controlled access and a gameroom for leisure and entertainment. Come discover why Cornerstone Park in Gibson Springs is the ultimate choice for those seeking a vibrant lifestyle combined with modern convenience in elegant two-bedroom layouts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Gibson Springs",
      "seo_description": "Cornerstone Park offers spacious 2 bedroom apartments in Gibson Springs, Henderson, NV, featuring modern amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-clark-county-cornerstone",
      "search_query": "3 bedroom apartments clark county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Clark County",
      "h2_subtitle": "Find expansive 3 bedroom apartments in Clark County at Cornerstone Park. Enjoy modern comfort and vibrant community living.",
      "page_copy": "Discover Cornerstone Park's three-bedroom apartments in Clark County, designed for those seeking the perfect balance of space and style. Our thoughtfully arranged floor plans provide ample room for families or those wanting extra space, complete with modern amenities that enhance daily living.\n\nLocated in the vibrant Gibson Springs area of Henderson, NV, our community offers more than just beautiful interiors. Residents enjoy access to basketball courts, serene walking trails, and inviting picnic areas, creating the ideal environment for recreation and relaxation. Experience the best of Clark County living with the conveniences and community atmosphere that Cornerstone Park provides.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Clark County",
      "seo_description": "Explore Cornerstone Park's spacious 3 bedroom apartments in Clark County, NV. Enjoy modern amenities and community features in a vibrant setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-near-touro-university-henderson",
      "search_query": "apartments near Touro University in Henderson NV",
      "category": "School",
      "h1_title": "Apartments Near Touro University, Henderson",
      "h2_subtitle": "Find convenient apartments near Touro University Nevada at Cornerstone Park. Enjoy modern living just minutes from campus.",
      "page_copy": "Cornerstone Park offers the ideal living solution for students and staff seeking apartments near Touro University in Henderson, NV. With a selection of stylish one, two, and three-bedroom layouts, our community provides the perfect home base for academic and professional pursuits. Each apartment is equipped with contemporary amenities including double vanities and a modern range, ensuring comfort and convenience.\n\nSituated in the inviting Gibson Springs neighborhood, just a short drive from Touro University, Cornerstone Park combines easy access to educational facilities with the tranquility of a serene residential area. Our community features such as controlled access and a gameroom enhance the overall living experience, making it a popular choice for those needing proximity to campus without sacrificing lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Touro University, Henderson",
      "seo_description": "Discover Cornerstone Park's convenient apartments near Touro University, Henderson. Enjoy modern living and easy access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-close-to-roseman-university-clark-county",
      "search_query": "apartments close to Roseman University of Health Sciences in Clark County",
      "category": "School",
      "h1_title": "Apartments Near Roseman University, Clark County",
      "h2_subtitle": "Discover apartments close to Roseman University at Cornerstone Park. Enjoy comfortable living in a prime educational hub in Clark County.",
      "page_copy": "Located in the heart of Clark County, Cornerstone Park offers ideal living options for students and staff seeking apartments close to Roseman University of Health Sciences. Our community provides a selection of modern one, two, and three-bedroom apartments, each featuring high-quality finishes and amenities such as double vanities and a sleek range, making it a seamless blend of practicality and style.\n\nNestled in the vibrant Gibson Springs neighborhood of Henderson, NV, Cornerstone Park offers convenient access to Roseman University while ensuring a peaceful residential setting. Our gated community features a gameroom and controlled access, creating an environment supportive of both academic success and recreational enjoyment. Experience the convenience and lifestyle benefits of residing at Cornerstone Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Roseman University, Clark County",
      "seo_description": "Explore Cornerstone Park's modern apartments close to Roseman University in Clark County, NV, combining convenience with a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-near-henderson-hospital-nv",
      "search_query": "apartments near Henderson Hospital NV",
      "category": "Hospital",
      "h1_title": "Apartments Near Henderson Hospital, NV",
      "h2_subtitle": "Explore spacious living at Cornerstone Park, near Henderson Hospital. Enjoy easy access and vibrant community amenities.",
      "page_copy": "Cornerstone Park offers a prime location for those looking for apartments near Henderson Hospital in NV. Our stylish one, two, and three-bedroom options provide the perfect sanctuary for healthcare professionals, patients, and families seeking proximity and convenience. Enhanced by modern features like double vanities and controlled access, each apartment is designed to cater to your everyday needs.\n\nNestled in the charming Gibson Springs area, the community encompasses tranquil walking trails, gated entry, and inviting picnic spots. This provides residents with both security and leisure, all within an easy commute to Henderson Hospital. Cornerstone Park is the ideal choice for those needing a comfortable, welcoming community close to healthcare facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Henderson Hospital, NV",
      "seo_description": "Discover Cornerstone Park's convenient apartments near Henderson Hospital, NV. Enjoy a secure community with vibrant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-close-to-st-rose-dominican-siena-campus",
      "search_query": "apartments close to St. Rose Dominican Siena Campus Gibson Springs",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Rose Dominican, Gibson Springs",
      "h2_subtitle": "Find comfort at Cornerstone Park, near St. Rose Dominican Siena Campus. Experience modern living in Gibson Springs.",
      "page_copy": "If you're searching for apartments close to St. Rose Dominican Siena Campus in the Gibson Springs area, look no further than Cornerstone Park. Our community offers chic one, two, and three-bedroom layouts, ideal for healthcare professionals, students, and families alike. With contemporary amenities like double vanities and a gameroom, every apartment ensures a balance of style and function.\n\nLocated in the serene neighborhood of Gibson Springs, Cornerstone Park provides quick access to the Siena Campus, while enveloping residents in a secure and vibrant community. Enjoy facilities like controlled access, basketball courts, and serene walking trails, making it an inviting choice for those who value convenience and a pleasant living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Rose Dominican, Gibson Springs",
      "seo_description": "Explore Cornerstone Park's modern apartments near St. Rose Dominican Siena Campus in Gibson Springs. Enjoy convenient access and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-near-sunset-park-henderson",
      "search_query": "apartments near Sunset Park Henderson",
      "category": "Park",
      "h1_title": "Apartments Near Sunset Park, Henderson",
      "h2_subtitle": "Discover living at Cornerstone Park, near Sunset Park. Enjoy nearby outdoor activities and community amenities.",
      "page_copy": "For those looking for serene apartments near Sunset Park in Henderson, Cornerstone Park stands out as a premier option. Choose from our stylish one, two, and three-bedroom apartments that offer modern comforts like double vanities and secure gated access. Each apartment is designed with both functionality and elegance in mind, perfect for families and individuals alike.\n\nLocated in the vibrant Gibson Springs neighborhood, residents at Cornerstone Park enjoy easy access to the recreational offerings of Sunset Park. The community provides additional amenities, such as a gameroom and basketball courts, ensuring an active, engaging lifestyle. Experience the best of Henderson living with both outdoor exploration and indoor relaxation right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunset Park, Henderson",
      "seo_description": "Find modern apartments near Sunset Park at Cornerstone Park in Henderson. Enjoy easy access to outdoor activities and community conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "rentals-close-to-heritage-park-nv",
      "search_query": "rentals close to Heritage Park NV",
      "category": "Park",
      "h1_title": "Rentals Close to Heritage Park, NV",
      "h2_subtitle": "Experience the best of living at Cornerstone Park, close to Heritage Park, NV. Enjoy unmatched community facilities.",
      "page_copy": "Discover convenient rentals close to Heritage Park, NV, at Cornerstone Park. Offering a range of stylish one, two, and three-bedroom floor plans, our community is ideal for anyone seeking comfort and location. Equipped with amenities like double vanities, a gameroom, and controlled access, Cornerstone Park units cater to all lifestyles.\n\nLocated in the Gibson Springs area, residents take pleasure in easy access to Heritage Park, a hub for recreational activities. The community’s inviting picnic areas and serene walking trails enhance the living experience, blending relaxation with activity. Whether you're a family or a professional, Cornerstone Park is the perfect spot to find a home near Heritage Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Heritage Park, NV",
      "seo_description": "Discover Cornerstone Park's prime rentals near Heritage Park, NV. Enjoy excellent amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "living-at-cornerstone-park-gibson-springs",
      "search_query": "living at Cornerstone Park Gibson Springs",
      "category": "Park",
      "h1_title": "Living at Cornerstone Park, Gibson Springs",
      "h2_subtitle": "Experience vibrant living at Cornerstone Park in Gibson Springs. Explore exceptional facilities and serene surroundings.",
      "page_copy": "Embrace the unique lifestyle offered by living at Cornerstone Park, nestled in the charming neighborhood of Gibson Springs. Our community showcases thoughtfully designed one, two, and three-bedroom apartments that prioritize modern living and comfort. With amenities such as double vanities, a gameroom, and gated access, residents enjoy a balanced blend of convenience and style.\n\nCornerstone Park is more than just a place to live; it's a place to thrive. The community features stunning outdoor spaces, including walking trails and basketball courts, perfect for relaxation and leisure. Ideally located in Henderson, residents have easy access to nearby shops, dining, and attractions, making it a vibrant place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living at Cornerstone Park, Gibson Springs",
      "seo_description": "Experience exceptional living at Cornerstone Park in Gibson Springs. Discover modern amenities and beautiful outdoor spaces in a dynamic community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-by-ethel-m-botanical-cactus-garden",
      "search_query": "apartments by Ethel M Botanical Cactus Garden",
      "category": "Park",
      "h1_title": "Apartments by Ethel M Botanical Cactus Garden",
      "h2_subtitle": "Discover Cornerstone Park, offering apartments by Ethel M Botanical Cactus Garden. Experience modern living in a serene setting.",
      "page_copy": "For those seeking a unique living experience, Cornerstone Park provides exceptional apartments by the Ethel M Botanical Cactus Garden. Our community offers stylish one, two, and three-bedroom apartments designed with modern amenities like double vanities and controlled access, catering to your comfort and lifestyle.\n\nSituated in Henderson's Gibson Springs neighborhood, Cornerstone Park places you just a stone's throw away from the serene beauty of the Ethel M Botanical Cactus Garden. Enjoy leisurely strolls or relaxing picnics in our inviting outdoor spaces, or take advantage of our gameroom and basketball courts for some active fun. Embrace the harmonious blend of nature and convenience at Cornerstone Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Ethel M Botanical Cactus Garden",
      "seo_description": "Explore Cornerstone Park's apartments near Ethel M Botanical Cactus Garden. Enjoy modern living with serene natural surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "housing-near-clark-county-wetlands-park",
      "search_query": "housing near Clark County Wetlands Park",
      "category": "Park",
      "h1_title": "Housing Near Clark County Wetlands Park",
      "h2_subtitle": "Find your ideal home at Cornerstone Park, close to Clark County Wetlands Park. Enjoy a vibrant lifestyle and excellent amenities.",
      "page_copy": "Explore the exceptional housing near Clark County Wetlands Park at Cornerstone Park. Our community offers thoughtfully designed one, two, and three-bedroom apartments that combine style and functionality. With features like double vanities, gated access, and a range of modern amenities, residents enjoy a superior living experience.\n\nLocated in the picturesque Gibson Springs area of Henderson, Cornerstone Park provides easy access to the natural wonders of Clark County Wetlands Park. Revel in the serene walking trails and outdoor recreational facilities that our community offers. Whether you prefer a quiet stroll or an active day out, Cornerstone Park offers the perfect setting for any lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Clark County Wetlands Park",
      "seo_description": "Discover modern housing options at Cornerstone Park, near Clark County Wetlands Park. Enjoy top amenities and a vibrant atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166430",
      "source": "generator",
      "page_item_url": "apartments-near-harry-reid-international-airport",
      "search_query": "apartments near harry reid international airport henderson",
      "category": "Transit",
      "h1_title": "Apartments Near Harry Reid International Airport",
      "h2_subtitle": "Discover Cornerstone Park - perfect apartments near Harry Reid International Airport in Henderson. Enjoy top-notch amenities and convenience.",
      "page_copy": "Looking for apartments near Harry Reid International Airport in Henderson? Cornerstone Park offers an ideal location with easy access to the airport, perfect for frequent travelers. Our community features thoughtfully designed one, two, and three-bedroom apartments, complete with modern amenities like double vanities and controlled access.\n\nEnjoy the convenience of living close to the airport, while also indulging in the serene surroundings of our community. Cornerstone Park, located in the pleasant Gibson Springs neighborhood, offers a range of amenities including a gameroom, basketball courts, and peaceful walking trails. It's the perfect balance of convenience, comfort, and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
      "featured_image_media": {
        "alt_text": "Pool with waterfall feature",
        "public_id": "019d02c8-0ea8-77b5-a27f-80dbc29ac8cf",
        "storage_key": "property/6767906449166430/019d02c8-0ea8-77b5-a27f-80dbc29ac8cf.webp",
        "width": 1024,
        "height": 682
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harry Reid International Airport",
      "seo_description": "Explore Cornerstone Park's prime location with apartments near Harry Reid International Airport. Enjoy comfort and convenience with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5300"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425284"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c1534892d7ef3a060aa41b84c832204a43299e5f9b2ec9ebc78ea3d42d938c5742ac1f50d6a1ae27959e235a325f3652\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NJCLV9S8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "44CST"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40240007191"
    },
    {
      "ID": "custom_show_price_guarantee",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "PM.0163249.BKR"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Cornerstone Park/scheduletourwidget/7tQcyLfhA4TTlFaxpW/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJZVUpISnkyOFFROFJPOWljenQvcGc9PSIsInZhbHVlIjoiSkMrbGFXY0RwTzBUbE5zOVpyajJIdz09IiwibWFjIjoiNWJkN2JhZDJjZWVjYjg2MjUxYmJjYTBiYTI2ZjMwNTYxNGUyMmM0NTFhNTJkZWJjZDc3MGRlMTE5Yjk2YWRiYyJ9"
    }
  ],
  "custom_qb_id": "5300",
  "custom_repli_id": "18104425284",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c1534892d7ef3a060aa41b84c832204a43299e5f9b2ec9ebc78ea3d42d938c5742ac1f50d6a1ae27959e235a325f3652\"></script>",
  "custom_google_gtm_id": "GTM-NJCLV9S8",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "44CST",
  "custom_hubspot_company_id": "40240007191",
  "custom_show_price_guarantee": "true",
  "custom_broker_license_number": "PM.0163249.BKR",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Cornerstone Park/scheduletourwidget/7tQcyLfhA4TTlFaxpW/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJZVUpISnkyOFFROFJPOWljenQvcGc9PSIsInZhbHVlIjoiSkMrbGFXY0RwTzBUbE5zOVpyajJIdz09IiwibWFjIjoiNWJkN2JhZDJjZWVjYjg2MjUxYmJjYTBiYTI2ZjMwNTYxNGUyMmM0NTFhNTJkZWJjZDc3MGRlMTE5Yjk2YWRiYyJ9",
  "custom_audioeye_site_id": "12c0b1bf-4dec-482c-baa7-54729da5abb2",
  "custom_audioeye_site_hash": "c3efc902751cbd604a55191edc18ebf3"
};

export const generatedAt = '2026-08-24T16:58:40.067Z';
